/**
 * ArticleTextSection 앵커 링크용 유틸.
 * - DOM `id`와 URL 해시 `#...`가 동일한 문자열이어야 브라우저/복사 링크가 맞습니다.
 */

/**
 * 제목 문자열을 DOM id / URL fragment로 쓰기 좋게 줄입니다 (앞뒤 공백 제거, 공백 → 하이픈).
 * 한글·영문 그대로 유지됩니다.
 */
export function slugifyFragmentId(text: string): string {
  return text.trim().replace(/\s+/g, '-');
}

/**
 * 현재 페이지 기준으로 해당 섹션으로 바로 가는 전체 URL을 만듭니다.
 * (SSR/테스트 등 `window` 없을 때는 `#sectionId`만 반환)
 */
export function buildArticleSectionUrl(sectionId: string): string {
  const id = sectionId.trim();
  if (!id) return '';
  if (typeof window === 'undefined') return `#${id}`;
  const { origin, pathname, search } = window.location;
  return `${origin}${pathname}${search}#${id}`;
}

/**
 * 섹션 공유 URL을 클립보드에 복사합니다. 성공 여부를 반환합니다.
 */
export async function copyArticleSectionUrlToClipboard(sectionId: string): Promise<boolean> {
  const url = buildArticleSectionUrl(sectionId);
  if (!url) return false;
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
